<template>
    <div>
        <el-col :span="4.8" v-for="(item,i) in lessonData" :key="i">
            <lesson-card class="p-pointer" :data="item[0]" @click.native="$router.push({path:'/home/lessons/study',query:{id:item[0].id,title:item[0].name}})"></lesson-card>
        </el-col>
    </div>
</template>
<script>
import lessonCard from '@p/components/lessonCard';
export default {
    components: { lessonCard },
    data() {
        return{
            visible: false,
            courseId:''
        }
    },
    props: {
        lessonData: {
            type: Array,
            default: function() {
                return []
            }
        }
    },
    methods:{
        visibleChange(rate,text) {
            this.$http.personal.evaluate({course_id:this.courseId,description:text,grade:rate}).then(res=>{
                if(res.status === 200){
                    console.log(res);
                    if (res.data.code==0) {
                        this.$message({message: res.data.message,type: 'success'});
                    }else{
                        this.$message({message: res.data.message,type: 'warning'});
                    }
                    this.$emit('getMyCourse','completed',0)
                }
                this.visible = false;
            }).catch(v=>{
                console.log(v);
            })
        },
        
    }
}
</script>
<style lang="less" scoped>
.lesson {
    width: 230px;
    height: 200px;
    margin: 12px 3px 12px 3px !important;
    .img{
        width: 220px;
        height: 120px;
    }
    .title{
        margin-top: 13px;
        margin-bottom: 10px;
        height: 22px;
        font-size: 16px;
        line-height: 22px;
        color: #404040;
    }
    .rate{
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        color: #333;
        span{
            margin-left: 5px;
        }
    }
}
</style>